// Module
var code = "<branch-values kind=\"'vatCodes'\"></branch-values>\n";
// Exports
module.exports = code;